import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, CATEGORY, fmtDate, STATUS } from "@/lib/api";
import { EmptyState, PageHeader, PriorityBadge, Spinner, StatusBadge } from "@/components/bits";
import { Button } from "@/components/ui/button";
import { Plus, Ticket } from "lucide-react";

export default function ClientTicketsPage() {
  const [tickets, setTickets] = useState(null);

  useEffect(() => {
    api.get("/tickets").then(({ data }) => setTickets(data)).catch(() => setTickets([]));
  }, []);

  if (!tickets) return <Spinner />;

  return (
    <div data-testid="client-tickets-page">
      <PageHeader title="Meus Chamados" subtitle="Acompanhe suas solicitações de suporte">
        <Link to="/portal/novo">
          <Button data-testid="client-new-ticket-button" className="bg-indigo-600 hover:bg-indigo-500 text-white rounded-md transition-colors duration-200">
            <Plus className="h-4 w-4 mr-1.5" /> Novo Chamado
          </Button>
        </Link>
      </PageHeader>

      {tickets.length === 0 ? (
        <EmptyState icon={Ticket} title="Você ainda não abriu chamados"
          subtitle="Clique em 'Novo Chamado' para solicitar suporte à equipe." />
      ) : (
        <div className="space-y-3">
          {tickets.map((t) => (
            <Link key={t.id} to={`/portal/chamados/${t.id}`} data-testid={`client-ticket-${t.id}`}
              className="block bg-zinc-900 border border-zinc-800 rounded-md p-4 hover:border-zinc-700 transition-colors duration-200">
              <div className="flex flex-wrap items-center gap-3">
                <span className="font-mono text-xs text-zinc-500">#{String(t.number).padStart(4, "0")}</span>
                <span className="text-sm font-medium text-zinc-100 flex-1 min-w-40">{t.title}</span>
                <PriorityBadge value={t.priority} />
                <StatusBadge value={t.status} />
              </div>
              <div className="flex items-center gap-3 mt-2 text-xs text-zinc-500">
                <span>{CATEGORY[t.category]}</span>
                <span>·</span>
                <span>Aberto em {fmtDate(t.created_at)}</span>
                <span>·</span>
                <span>Última atualização {fmtDate(t.updated_at)}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
